import { css } from "@/domains/emotion";
import { FC } from "react";
import { googleIdentityModule } from "@/modules/google-identity";
import memLogomarkImage from "@/assets/images/logomark.svg";
import { Box, Button, Card, Flex, Heading } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";
import { atlasRoutes } from "@/app/router/routes";
import styled from "@emotion/styled";

export const LogInPage: FC = () => {
  const navigate = useNavigate();
  const logInWithGoogle = () => googleIdentityModule.triggerLogIn();

  return (
    <LoginPageWrapper>
      <Box>
        <Card className={cardStyles}>
          <Flex direction="column" gap="8" align="center">
            <Heading>Atlas</Heading>
            <img className={imageStyles} src={memLogomarkImage} alt="Mem Logo" />
            <Flex direction="column" gap="2">
              <Button onClick={logInWithGoogle}>Log In With Google</Button>
              <Button
                variant="outline"
                onClick={() => navigate(atlasRoutes.logInEmailPassword({}).path)}
              >
                Log In With Email
              </Button>
            </Flex>
          </Flex>
        </Card>
      </Box>
    </LoginPageWrapper>
  );
};

const LoginPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
`;

const cardStyles = css({
  padding: "32px 80px",
  marginBottom: 80,
});

const imageStyles = css({
  width: 32,
  height: 32,
});
